import { render, staticRenderFns } from "./AdminTooltipForm.vue?vue&type=template&id=5b2b13b4&scoped=true&"
import script from "./AdminTooltipForm.vue?vue&type=script&lang=js&"
export * from "./AdminTooltipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b13b4",
  null
  
)

export default component.exports